"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateJoi = void 0;
const joi_1 = __importDefault(require("@hapi/joi"));
const validateJoi = (schema = joi_1.default.object()) => (payload) => {
    const { value, error } = joi_1.default.validate(payload, schema, { allowUnknown: true, stripUnknown: true });
    // tslint:disable-next-line:strict-boolean-expressions
    if (error) {
        throw error;
    }
    else {
        return value;
    }
};
exports.validateJoi = validateJoi;
